import * as yup from 'yup';
import { ColDef } from 'ag-grid-community';
import { AgTable } from '../../../../../components/AgTable/AgTable';
import { usdField } from '../../../../../schemas/common-schema-defs';
import { useSchemaToGrid } from '../../../../../util/schema-utils';
import { IMetricsDataModel } from '../../../../../data-models/metrics.data-model';
import { ICompanyDataModel } from '../../../../../data-models/company.data-model';

const defaultColDef: ColDef = {
  flex: 1,
  minWidth: 200,
};

export interface IAcquiredGridProps {
  company: ICompanyDataModel;
  companyMetrics: IMetricsDataModel;
}
export function ExitDetailsGrid(props: IAcquiredGridProps) {
  const { company, companyMetrics } = props;
  const getColDefs = useSchemaToGrid();
  const data: ExitDetailsRowData = {
    acquisitionDate: companyMetrics.acquisitionDate ? new Date(companyMetrics.acquisitionDate) : undefined,
    acquirer: company.acquirer?.fields?.name ?? '',
    proceeds: companyMetrics.distributions,
    exitValuation: company.exitValuation,
    acquisitionShares: companyMetrics.acquisitionShares,
  };

  return (
    <AgTable
      columnDefs={getColDefs(getExitDetailsGridSchema())}
      groupDefaultExpanded={-1}
      rowData={[data]}
      rowGroupPanelShow='never'
      suppressMovableColumns={true}
      suppressRowDrag={true}
      defaultColDef={defaultColDef}
    />
  );
}

function getExitDetailsGridSchema() {
  return yup.object({
    acquisitionDate: yup.date().gridMeta({
      formatter: 'dateNumeric',
    }),
    acquirer: yup.string(),
    proceeds: usdField(),
    exitValuation: usdField().nullable(),
    acquisitionShares: yup.number().label('Acquirer Shares'),
  });
}

type ExitDetailsRowData = yup.InferType<ReturnType<typeof getExitDetailsGridSchema>>;
